import React from 'react';
import PropTypes from 'prop-types';
import { getClassName } from '../../../utils/ui/classes';
const ExternalLinkIcon = ({ className, type }) => {
    if (type === 'solid') {
        return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: getClassName(className), viewBox: "0 0 20 20", fill: "currentColor" },
            React.createElement("path", { d: "M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" }),
            React.createElement("path", { d: "M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" })));
    }
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: getClassName(className), fill: "none", viewBox: "0 0 24 24", stroke: "currentColor" },
        React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" })));
};
ExternalLinkIcon.propTypes = {
    type: PropTypes.oneOf(['solid', 'outline']),
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
};
ExternalLinkIcon.defaultProps = {
    type: 'solid',
    className: 'w-6 h-6',
};
export default ExternalLinkIcon;
